import { useField } from '@ff-it/form';
import type { EmbeddedCompany } from 'types';

export function useConcreteClientId(): number | undefined {
  const client = useField<EmbeddedCompany | null>('client', { subscription: { value: true } }).input.value;

  return client?.parent || client?.id;
}
